export enum GaitDetailTab {
    RIDE = 'RIDE',
    PROFILE = 'PROFILE',
    SETTINGS = 'SETTINGS'
}
